import { INotification } from "../types/notification";


const isUserUnReadNotification = (notification: INotification, userId: string) => {
    return !(notification.readBy?.length  && (notification.readBy?.some((item: any) => item.userId == userId)))
  };
export { isUserUnReadNotification };